import { useState } from "react"
import Contact from "./components/Contact"
import Hero from "./components/Hero"
import Works from "./components/Works"
import Modal from "./components/Modal"
import "./css/App.css"
import data from "./data.js"
const { contact, profile, works } = data

function App() {
  const modal = {
    isOpen: false,
  }
  const work = { items: works, selected: null }
  const [appState, setState] = useState({ modal, work })
  return (
    <>
      {appState?.modal?.isOpen && <Modal {...{ appState, setState }} />}
      <Hero profile={profile} />
      <div className="content">
        <div className="fade"></div>

        <Works {...{ appState, setState }} />
        <Contact contact={contact} />
      </div>
    </>
  )
}

export default App
